var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-dropdown",
    { attrs: { variant: "primary", size: "sm", text: "Templates" } },
    [
      _c(
        "b-dropdown-form",
        [
          _c(
            "b-list-group",
            { attrs: { flush: "" } },
            [
              _c(
                "b-list-group-item",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { size: "sm" },
                      on: { change: _vm.toggleSelectAll },
                      model: {
                        value: _vm.isSelectedAllTemplate,
                        callback: function ($$v) {
                          _vm.isSelectedAllTemplate = $$v
                        },
                        expression: "isSelectedAllTemplate",
                      },
                    },
                    [_vm._v("\n          Select All\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.instances, function (instance) {
                return _c(
                  "b-list-group-item",
                  { key: instance.id },
                  [
                    _c(
                      "b-form-checkbox",
                      {
                        attrs: {
                          size: "sm",
                          disabled: instance.id === _vm.selectedInstance.id,
                        },
                        model: {
                          value: instance.selected,
                          callback: function ($$v) {
                            _vm.$set(instance, "selected", $$v)
                          },
                          expression: "instance.selected",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.getInstanceName(instance.id)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("b-dropdown-form"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }